export default {
    baseUrl: 'https://backend-rose-five-53.vercel.app/api',
    baseurl : 'https://backend-rose-five-53.vercel.app/api'

  };
  
